import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useAdfoxContext } from 'shared/context/AdfoxContext';

import { useAdBannerMicrofrontendParameters, useAdBannerMicrofrontend } from './hooks';
import { useMicrofrontEvents } from './hooks/useMicrofrontEvents';

export interface IAdBannerMicrofrontendProps {
  onClose?(): void;
}

export const AdBannerMicrofrontend: React.FC<IAdBannerMicrofrontendProps> = ({ onClose }) => {
  const { isHidden: isHiddenByContext } = useAdfoxContext();
  const parameters = useAdBannerMicrofrontendParameters();
  const { manifest, microfrontendRef, isReady } = useAdBannerMicrofrontend();

  const { isHidden } = useMicrofrontEvents(microfrontendRef, isReady, onClose);

  if (isHidden || isHiddenByContext || !manifest || !isReady) {
    return null;
  }

  return (
    <Microfrontend
      ref={microfrontendRef}
      name={manifest.microfrontendName}
      image={manifest.imageVersion}
      runtime={manifest.runtimeName}
      parameters={parameters}
    />
  );
};
